import {
  CREATE_PARTIAL_USER_SUCCESS,
  REFRESH_TOKEN_SUCCESS,
  SEND_EXTERNAL_AUTH_TOKEN_SUCCESS,
  LOGIN_SUCCESS,
  REGISTER_USER_SUCCESS,
} from 'actionTypes';

const initialState = {
  token: null,
  currentUserId: null,
};

export default function authReducer(state = initialState, action) {
  const { type, token, normalizedData } = action;
  switch (type) {
    case LOGIN_SUCCESS:
    case REGISTER_USER_SUCCESS:
    case CREATE_PARTIAL_USER_SUCCESS:
    case SEND_EXTERNAL_AUTH_TOKEN_SUCCESS:
      return {
        token: token,
        currentUserId: normalizedData.result,
      };
    case REFRESH_TOKEN_SUCCESS:
      return {
        ...state,
        token: token,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/authReducer.js